<p-breadcrumb
  [model]="[
    { label: 'Regras de Avaliação', routerLink: ['/assessment-rules'] },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Regras de Avaliação</h5>
      <p>Gerencie as regras aplicadas nas avaliações</p>
    </div>
    <p-button
      label="Nova Regra"
      routerLink="/assessment-rules/create"
      rounded
    />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="assessmentRules()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome"
          class="w-full"
        />
      </div>
      <div class="w-100">
        <p-select
          [options]="assessmentsDropdown()"
          [loading]="assessmentSelectLoading()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Selecione uma avaliação"
          class="w-full"
          [(ngModel)]="assessmentIdFilter"
          (ngModelChange)="onFilterChange()"
        >
        </p-select>
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Nome</th>
      <th>Condição</th>
      <th>Mensagem de falha</th>
      <th>Avaliação</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.name }}</td>
      <td>{{ item.condition }}</td>
      <td>{{ item.failureMessage }}</td>
      <td>{{ item.assessmentName }}</td>
      <td>
        <div
          class="flex justify-start"
          (click)="requestUpdateStatus(item, $event)"
        >
          <div class="flex items-center gap-2">
            <p-toggleswitch
              [ngModel]="item.isActive"
              [style.pointer-events]="'none'"
            ></p-toggleswitch>
            {{ item.isActive ? "Ativo" : "Inativo" }}
          </div>
        </div>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/assessment-rules/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
<p-confirmdialog />
